var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconArrowRight08 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  className: "icon_arrow_right_08_svg__sc-17dt15x-66 icon_arrow_right_08_svg__ibhodu",
  viewBox: "0 0 42 42"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 21,
  r: 20.5,
  stroke: "#000"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#434343",
  strokeLinejoin: "round",
  strokeWidth: 1.3,
  d: "m18 13 8 8-8 8"
})));
export default SvgIconArrowRight08;